

































































import { defineComponent, onMounted, ref } from "@vue/composition-api";
import Page from "@/components/layout/page.vue";
import PageHeader from "@/components/navigation/page-header.vue";
import DataTable from "@/components/data/data-table.vue";
import { User } from "@/swagger/models";
import { DataTableConfig } from "@/components/data/data-table";
import { useRouter } from "@/router/router";
import { userService } from "@/services/user";
import user from "@/views/users/user.vue";
import { UserRole, UserRoleDisplay } from "@/types/roles";

export default defineComponent({
    name: "users-table",
    props: {
        customerId: {
            type: Number,
            required: true,
        },
    },
    components: { Page, PageHeader, DataTable },
    setup(props, context) {
        const { router } = useRouter(context);

        const users = ref<User[]>([]);
        const loading = ref(false);

        onMounted(async function () {
            loading.value = true;
            users.value = await userService.find({ params: { customer: props.customerId } });
            loading.value = false;

            context.emit("update:count", users.value.length);
        });

        const tableConfig: DataTableConfig<User> = {
            clickItemCallback: (item) => {
                router.push({
                    name: "user",
                    params: {
                        userId: item.id.toString(),
                    },
                });
            },
            items: users,
            fields: [
                {
                    label: "ID",
                    field: "id",
                    compact: true,
                },
                {
                    label: "Name",
                    field: "name",
                },
                {
                    label: "Teams",
                    field: "teams",
                },
                {
                    label: "Status",
                    field: "okta.status",
                    compact: true,
                    format: (status: string) => status?.toLowerCase(),
                },
                {
                    label: "Role",
                    field: "okta.profile.userType",
                    compact: true,
                    defaultValue: UserRoleDisplay.user.toLowerCase(),
                    format: (role: string) => (UserRoleDisplay[role] as string)?.toLowerCase(),
                },
                {
                    label: "Created",
                    field: "createdAt",
                    compact: true,
                },
                {
                    label: "Updated",
                    field: "updatedAt",
                    compact: true,
                },
            ],
        };

        return { tableConfig, loading };
    },
});
